import React from 'react';
import { Grid, Table, TableBody, TableHead, TableRow, Typography } from '@material-ui/core';
import TableCell from 'src/components/TableCell';
import Card from 'src/components/Card';
import EmployeeRow from './components/EmployeeRow';
import LegacyEmployeeInput from './components/LegacyEmployeeInput';
import DateRangeContainer from '../../components/DateRangeContainer';
import TotalRow from './components/TotalRow';
import useEmployeeStats from './hooks/useEmployeeStats';

const EmployeeReport = () => {
  const { startDate, endDate, setStartDate, setEndDate, employeesIds, addEmployeeId } = useEmployeeStats();

  return (
    <Card>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant='h6' id='tableTitle' component='div'>
            Rapport équipe commerciale
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <DateRangeContainer
            startDate={startDate}
            endDate={endDate}
            onStartDateChange={setStartDate}
            onEndDateChange={setEndDate}
          />
        </Grid>

        <Grid item xs={12} style={{ overflowX: 'auto' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Employés</TableCell>
                <TableCell>RDV réalisés</TableCell>
                <TableCell>Comptes créés</TableCell>
                <TableCell>Affaires créées</TableCell>
                <TableCell>Pdc affaires&nbsp;créées</TableCell>
                <TableCell>Affaires gagnées</TableCell>
                <TableCell>Pdc affaires&nbsp;gagnées</TableCell>
                <TableCell>Affaires perdues</TableCell>
                <TableCell>%&nbsp;conv</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>

            <TableBody>
              {employeesIds.map((employeeId) => (
                <EmployeeRow
                  key={employeeId}
                  employeeId={employeeId}
                  startDate={startDate || undefined}
                  endDate={endDate || undefined}
                />
              ))}

              <TableRow>
                <TableCell colSpan={10}>
                  <LegacyEmployeeInput onPickEmployee={addEmployeeId} />
                </TableCell>
              </TableRow>

              <TotalRow />
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </Card>
  );
};

export default EmployeeReport;
